import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color = '#3b82f6',
  className = ''
}) => {
  const sizeMap = {
    small: '1rem',
    medium: '2rem',
    large: '3rem'
  };
  
  const styles = require("./LoadingSpinner.module.scss");
  
  return (
    <div className={`${styles.spinnerContainer} ${className}`}>
      <div 
        className={styles.spinner}
        style={{
          width: sizeMap[size],
          height: sizeMap[size],
          borderColor: `${color} transparent transparent transparent`
        }}
      ></div>
    </div>
  );
};

export default LoadingSpinner;